'use client';

import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';
import { useLocale, useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import RichText from '@/app/components/RichText';

const Content = () => {
  const selectedLocale = useLocale();
  const t = useTranslations();
  return (
    <LayoutGrid>
      <div className="col-main">
        <TypographyRhythm>
          <Typography variant="h1" Element="h1">
            {t('accessibility_title')}
          </Typography>

          <Typography>
            <RichText
              messageKey="accessibility_body_1"
              tValues={{
                link: () => (
                  <BodyLink
                    href={`https://ouraring.com/${selectedLocale}`}
                    color="inherit"
                  >
                    ouraring.com
                  </BodyLink>
                ),
              }}
            />
          </Typography>

          <Typography>
            <RichText
              messageKey="accessibility_body_2"
              tValues={{
                link: (chunks: ReactNode) => (
                  <BodyLink
                    external
                    href="https://support.ouraring.com"
                    color="inherit"
                    target="_blank"
                  >
                    {chunks}
                  </BodyLink>
                ),
              }}
            />
          </Typography>

          <Typography>
            <BodyLink
              color="inherit"
              href="/accessibility/en"
              data-cy="en-accessibility-statement-link"
            >
              English Accessibility Statement
            </BodyLink>
          </Typography>
          <Typography>
            <BodyLink
              color="inherit"
              href="/accessibility/fi"
              data-cy="fi-accessibility-statement-link"
            >
              Finnish Saavutettavuusseloste
            </BodyLink>
          </Typography>
        </TypographyRhythm>
      </div>
    </LayoutGrid>
  );
};

export default Content;
